(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (window.innerWidth >= 750) {
    document.querySelectorAll('.footer__column-details').forEach(details => {
      details.open = true;
    });
  }

  window.addEventListener('resize', () => {
    const details = document.querySelectorAll('.footer__column-details');
    if (window.innerWidth >= 750) {
      details.forEach(detail => {
        detail.open = true;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let header = document.querySelector('.site-header');
    
    if (!header) return;

    // Announcement Slider with hide/show on scroll
    const sliderWrapper = document.querySelector('.announcement-slider-wrapper');

    // Keep CSS vars in sync even when the announcement bar is disabled (no blocks)
    let headerContainer = header.querySelector('.header-container');
    function updateHeaderAnnouncementVars() {
      document.documentElement.style.setProperty('--header-height', (headerContainer ? headerContainer.offsetHeight : header.offsetHeight) + 'px');
      if (sliderWrapper) {
        document.documentElement.style.setProperty('--announcement-height', sliderWrapper.offsetHeight + 'px');
      } else {
        document.documentElement.style.setProperty('--announcement-height', '0px');
      }
    }

    // Initial measurement + keep updated on resize
    updateHeaderAnnouncementVars();
    window.addEventListener('resize', updateHeaderAnnouncementVars);

    if (sliderWrapper) {
      const slides = sliderWrapper.querySelectorAll('.announcement-slide');
      const dots = sliderWrapper.querySelectorAll('.announcement-dot');
      const prevBtn = sliderWrapper.querySelector('.announcement-prev');
      const nextBtn = sliderWrapper.querySelector('.announcement-next');
      const autoplay = sliderWrapper.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(sliderWrapper.dataset.autoplaySpeed) || 5000;
      const hideOnScroll = sliderWrapper.dataset.hideOnScroll === 'true';
      const displayMode = sliderWrapper.dataset.displayMode || 'slider';
      const marqueeSpeed = parseInt(sliderWrapper.dataset.marqueeSpeed) || 40;
      
      let currentSlide = 0;
      let autoplayInterval;
      let lastScrollY = window.scrollY;
      let ticking = false;

      // Initialize Marquee Mode
      if (displayMode === 'marquee') {
        const slider = sliderWrapper.querySelector('.announcement-slider');
        
        // Combine all announcement texts
        const allTexts = [];
        slides.forEach(slide => {
          const content = slide.querySelector('.announcement-content');
          if (content) {
            allTexts.push(content.innerHTML);
          }
        });
        
        // Create the scrolling text with bullet separators
        const combinedText = allTexts.join(' &nbsp;•&nbsp; ') + ' &nbsp;•&nbsp; ';
        
        // Clear existing content
        slider.innerHTML = '';
        
        // Create marquee slide with proper background
        const marqueeSlide = document.createElement('div');
        marqueeSlide.className = 'announcement-slide active';
        marqueeSlide.style.cssText = `
          background: ${slides[0].style.getPropertyValue('--announcement-bg-color') || '#000'};
          color: ${slides[0].style.getPropertyValue('--announcement-text-color') || '#fff'};
          min-height: ${slides[0].style.getPropertyValue('--announcement-height') || '40px'};
        `;
        
        // Create the marquee content wrapper
        const marqueeWrapper = document.createElement('div');
        marqueeWrapper.className = 'announcement-content';
        marqueeWrapper.style.cssText = `
          display: block;
          width: 100%;
          overflow: hidden;
          font-size: ${slides[0].style.getPropertyValue('--announcement-font-size') || '12px'};
          color: ${slides[0].style.getPropertyValue('--announcement-text-color') || '#fff'};
        `;
        
        // Create the scrolling track
        const marqueeTrack = document.createElement('div');
        marqueeTrack.className = 'marquee-track';
        
        // Create a temporary span to measure text width
        const tempSpan = document.createElement('span');
        tempSpan.className = 'marquee-text';
        tempSpan.innerHTML = combinedText;
        tempSpan.style.cssText = 'display: inline-block; white-space: nowrap; visibility: hidden; position: absolute;';
        marqueeWrapper.appendChild(tempSpan);
        marqueeSlide.appendChild(marqueeWrapper);
        slider.appendChild(marqueeSlide);
        
        // Wait for next frame to measure
        requestAnimationFrame(() => {
          const textWidth = tempSpan.offsetWidth;
          const viewportWidth = window.innerWidth;
          
          // Calculate how many copies we need (at least 3x viewport width for smooth scrolling)
          const minWidth = viewportWidth * 3;
          const copiesNeeded = Math.ceil(minWidth / textWidth) + 1;
          
          // Remove temp span
          tempSpan.remove();
          
          // Now create the actual track with proper number of copies
          marqueeTrack.innerHTML = '';
          marqueeTrack.style.cssText = 'display: inline-flex; width: max-content;';
          
          for (let i = 0; i < copiesNeeded; i++) {
            const span = document.createElement('span');
            span.className = 'marquee-text';
            span.innerHTML = combinedText;
            span.style.cssText = 'display: inline-block; white-space: nowrap;';
            marqueeTrack.appendChild(span);
          }
          
          marqueeWrapper.appendChild(marqueeTrack);
          
          // Calculate the percentage to move (move by one copy's worth)
          const movePercentage = (100 / copiesNeeded);
          
          // Apply animation with dynamic keyframes
          const styleSheet = document.createElement('style');
          styleSheet.textContent = `
            @keyframes marqueeScrollDynamic {
              0% { transform: translateX(0); }
              100% { transform: translateX(-${movePercentage}%); }
            }
          `;
          document.head.appendChild(styleSheet);
          
          marqueeTrack.style.animation = `marqueeScrollDynamic ${marqueeSpeed}s linear infinite`;
        });
      }

      function goToSlide(index) {
        if (displayMode === 'marquee') return;
        
        slides.forEach(slide => slide.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));
        
        if (slides[index]) slides[index].classList.add('active');
        if (dots[index]) dots[index].classList.add('active');
        
        currentSlide = index;
        
        // Update announcement height CSS variable for header positioning
        setTimeout(() => {
          const height = sliderWrapper.offsetHeight;
          document.documentElement.style.setProperty('--announcement-height', height + 'px');
        }, 50);
      }

      function nextSlide() {
        if (displayMode === 'marquee') return;
        const next = (currentSlide + 1) % slides.length;
        goToSlide(next);
      }

      function prevSlide() {
        if (displayMode === 'marquee') return;
        const prev = (currentSlide - 1 + slides.length) % slides.length;
        goToSlide(prev);
      }

      function startAutoplay() {
        if (displayMode === 'marquee') return;
        if (autoplay && slides.length > 1) {
          autoplayInterval = setInterval(nextSlide, autoplaySpeed);
        }
      }

      function stopAutoplay() {
        if (displayMode === 'marquee') return;
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
        }
      }

      // Dot navigation
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
          stopAutoplay();
          startAutoplay();
        });
      });

      // Arrow navigation
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prevSlide();
          stopAutoplay();
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          nextSlide();
          stopAutoplay();
          startAutoplay();
        });
      }

      // Pause on hover
      sliderWrapper.addEventListener('mouseenter', stopAutoplay);
      sliderWrapper.addEventListener('mouseleave', startAutoplay);

      // Cache heights (reading offsetHeight forces layout; avoid doing it on every scroll)
      let cachedAnnouncementHeight = sliderWrapper.offsetHeight;
      let cachedHeaderHeight = header.offsetHeight;
      const hdrContainer = header.querySelector('.header-container');
      document.documentElement.style.setProperty('--announcement-height', cachedAnnouncementHeight + 'px');
      document.documentElement.style.setProperty('--header-height', (hdrContainer ? hdrContainer.offsetHeight : cachedHeaderHeight) + 'px');
      document.documentElement.style.setProperty('--header-top', (header.classList.contains('header-always-show') ? (cachedAnnouncementHeight + 'px') : '0px'));

      // Track last applied states so we don't spam style writes every scroll frame
      let appliedAnnouncementVisible = null; // true/false
      let appliedHeaderTop = null;           // '0px' / '30px' etc

      // Scroll direction detection - Hide on scroll down, show on scroll up
      if (hideOnScroll) {
        function handleScroll() {
          // Don't change header position when drawer is open
          if (document.body.classList.contains('drawer-open')) {
            ticking = false;
            return;
          }
          
          const currentScrollY = window.scrollY;
          const isHeaderFixed = header.classList.contains('header-always-show');

          const shouldShowAnnouncement = currentScrollY <= 5;

          // At the very top -> show announcement and push header below it
          if (shouldShowAnnouncement) {
            if (appliedAnnouncementVisible !== true) {
              sliderWrapper.classList.remove('hidden');
              document.documentElement.style.setProperty('--announcement-height', cachedAnnouncementHeight + 'px');
              appliedAnnouncementVisible = true;
            }

            if (isHeaderFixed) {
              const nextTop = cachedAnnouncementHeight + 'px';
              if (appliedHeaderTop !== nextTop) {
                header.style.top = nextTop;
                document.documentElement.style.setProperty('--header-top', nextTop);
                appliedHeaderTop = nextTop;
              }
            }
          } else {
            // Not at the top -> keep announcement hidden and header at top
            if (appliedAnnouncementVisible !== false) {
              sliderWrapper.classList.add('hidden');
              document.documentElement.style.setProperty('--announcement-height', '0px');
              appliedAnnouncementVisible = false;
            }

            if (isHeaderFixed) {
              const nextTop = '0px';
              if (appliedHeaderTop !== nextTop) {
                header.style.top = '0';
                document.documentElement.style.setProperty('--header-top', nextTop);
                appliedHeaderTop = nextTop;
              }
            }
          }

          lastScrollY = currentScrollY;
          ticking = false;
        }

        window.addEventListener('scroll', () => {
          if (!ticking) {
            window.requestAnimationFrame(handleScroll);
            ticking = true;
          }
        });
        
        // Check initial scroll position on page load
        window.requestAnimationFrame(handleScroll);
      } else {
        // hideOnScroll is OFF - FORCE announcement to always stay visible
        // Remove hidden class if it somehow got added
        sliderWrapper.classList.remove('hidden');
        
        // Clear any inline styles that might hide it
        sliderWrapper.style.transform = '';
        sliderWrapper.style.opacity = '';
        sliderWrapper.style.visibility = '';
        
        // Set up a scroll listener that ENFORCES visibility
        window.addEventListener('scroll', () => {
          // Always remove hidden class
          if (sliderWrapper.classList.contains('hidden')) {
            sliderWrapper.classList.remove('hidden');
          }
          
          // Always ensure proper positioning (use cached heights to avoid layout reads)
          if (header.classList.contains('header-always-show') && cachedAnnouncementHeight > 0) {
            const nextTop = cachedAnnouncementHeight + 'px';
            if (appliedHeaderTop !== nextTop) {
              header.style.top = nextTop;
              document.documentElement.style.setProperty('--header-top', nextTop);
              appliedHeaderTop = nextTop;
            }
          }
        });
      }

      // Initialize
      if (displayMode === 'slider') {
        goToSlide(0);
        startAutoplay();
      }
      
      // Set initial heights for CSS vars used across the theme
      setTimeout(() => {
        cachedAnnouncementHeight = sliderWrapper.offsetHeight;
        cachedHeaderHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--announcement-height', cachedAnnouncementHeight + 'px');
        document.documentElement.style.setProperty('--header-height', (hdrContainer ? hdrContainer.offsetHeight : cachedHeaderHeight) + 'px');

        // Don't change header position when drawer is open
        if (document.body.classList.contains('drawer-open')) {
          return;
        }
        
        // Position fixed header
        if (header.classList.contains('header-always-show')) {
          if (hideOnScroll) {
            // When Hide on Scroll is ON - position based on scroll
            const currentScrollY = window.scrollY;
            if (currentScrollY <= 5 && !sliderWrapper.classList.contains('hidden')) {
              header.style.top = cachedAnnouncementHeight + 'px';
              document.documentElement.style.setProperty('--header-top', cachedAnnouncementHeight + 'px');
              appliedHeaderTop = cachedAnnouncementHeight + 'px';
            } else {
              header.style.top = '0';
              document.documentElement.style.setProperty('--header-top', '0px');
              appliedHeaderTop = '0px';
            }
          } else {
            // When Hide on Scroll is OFF - ALWAYS keep header below announcement
            header.style.top = cachedAnnouncementHeight + 'px';
            document.documentElement.style.setProperty('--header-top', cachedAnnouncementHeight + 'px');
            appliedHeaderTop = cachedAnnouncementHeight + 'px';
          }
        }
      }, 100);
      
      // Update height on window resize
      window.addEventListener('resize', () => {
        cachedAnnouncementHeight = sliderWrapper.offsetHeight;
        cachedHeaderHeight = header.offsetHeight;
        // Only keep announcement height in the CSS var when it's actually visible
        const announcementIsVisible = !sliderWrapper.classList.contains('hidden');
        document.documentElement.style.setProperty('--announcement-height', announcementIsVisible ? (cachedAnnouncementHeight + 'px') : '0px');
        document.documentElement.style.setProperty('--header-height', (hdrContainer ? hdrContainer.offsetHeight : cachedHeaderHeight) + 'px');
        
        // Don't change header position when drawer is open
        if (document.body.classList.contains('drawer-open')) {
          return;
        }
        
        // Update header position if it's fixed
        if (header.classList.contains('header-always-show')) {
          if (hideOnScroll) {
            // Only update if announcement is visible
            if (!sliderWrapper.classList.contains('hidden')) {
              header.style.top = cachedAnnouncementHeight + 'px';
              document.documentElement.style.setProperty('--header-top', cachedAnnouncementHeight + 'px');
              appliedHeaderTop = cachedAnnouncementHeight + 'px';
            }
          } else {
            // When Hide on Scroll is OFF - ALWAYS keep header below announcement
            header.style.top = cachedAnnouncementHeight + 'px';
            document.documentElement.style.setProperty('--header-top', cachedAnnouncementHeight + 'px');
            appliedHeaderTop = cachedAnnouncementHeight + 'px';
          }
        }
      });
    }

    // ========== SCROLL CONTROLLER (window.StackdHeader) ==========
    // Single controller for: scroll transparency, scroll fade, trigger system.
    // Uses data attributes for state, AbortController for clean teardown.
    window.StackdHeader = {
      header: null,
      abortController: null,
      scrollBehavior: 'off',
      revealPosition: 80,
      fadeEnd: 200,
      fadeMax: 1,
      fadeRange: 120,
      transparentOnPage: false,
      currentState: 'default',
      ticking: false,

      // Original CSS variable values (before transparent override)
      origBg: '', origBorder: '', origText: '', origNav: '', origCartCount: '',

      // Glass offset animation
      bgPadding: 0,
      maxGlassOffset: 0,

      // Trigger system
      startEl: null, endEl: null, staticBgEl: null,
      hasStart: false, hasEnd: false, hasTriggers: false,
      lastClipKey: '',

      init: function() {
        this.header = document.querySelector('.site-header');
        if (!this.header) return;

        // Also update outer scope references for announcement bar
        header = this.header;
        headerContainer = this.header.querySelector('.header-container');
        updateHeaderAnnouncementVars();

        this.abortController = new AbortController();
        var signal = this.abortController.signal;
        var self = this;

        // Read config from data attributes
        this.scrollBehavior = this.header.dataset.scrollBehavior || 'off';
        this.revealPosition = parseInt(this.header.dataset.revealPosition || '80', 10);
        this.fadeEnd = parseInt(this.header.dataset.scrollFadeEnd || '200', 10);
        var fadeMaxRaw = parseInt(this.header.dataset.scrollFadeMax || '100', 10);
        this.fadeMax = Math.min(fadeMaxRaw, 100) / 100;
        if (this.fadeEnd <= this.revealPosition) this.fadeEnd = this.revealPosition + 1;
        this.fadeRange = this.fadeEnd - this.revealPosition;

        // Read bg-padding from :root for glass offset animation
        var rootBgPadding = getComputedStyle(document.documentElement).getPropertyValue('--bg-padding').trim();
        this.bgPadding = parseFloat(rootBgPadding) || 0;
        this.maxGlassOffset = this.bgPadding / 2;

        // Reset state
        this.currentState = 'default';
        this.lastClipKey = '';

        // Detect per-page transparency
        this.transparentOnPage = this._detectTransparentPage();

        // Cache original CSS variable values
        var cs = getComputedStyle(this.header);
        this.origBg = cs.getPropertyValue('--header-bg-color').trim();
        this.origBorder = cs.getPropertyValue('--header-border-color').trim();
        this.origText = cs.getPropertyValue('--header-text-color').trim();
        this.origNav = cs.getPropertyValue('--nav-text-color').trim();
        this.origCartCount = cs.getPropertyValue('--cart-count-color').trim();

        // Initialize triggers
        this.startEl = document.querySelector('[data-header-bg-start]');
        this.endEl = document.querySelector('[data-header-bg-end]');
        this.hasStart = !!this.startEl;
        this.hasEnd = !!this.endEl;
        this.hasTriggers = this.hasStart || this.hasEnd;
        this.staticBgEl = document.querySelector('.header-static-bg');

        if (this.hasTriggers) {
          this._updateTriggerClip();
        } else {
          document.documentElement.style.setProperty('--trigger-clip-top', '0');
          document.documentElement.style.setProperty('--trigger-clip-bottom', '0');
          window.__headerBgTriggerProgress = 1;
        }

        // Bind events
        var onScroll = function() { self._onScroll(); };
        window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
        document.addEventListener('scroll', onScroll, { capture: true, passive: true, signal: signal });
        window.addEventListener('resize', function() {
          self._onScroll();
        }, { signal: signal });
        window.addEventListener('pageshow', onScroll, { signal: signal });
        window.addEventListener('load', onScroll, { signal: signal });
        document.addEventListener('shopify:section:select', onScroll, { signal: signal });

        // Set initial state
        this._update(window.scrollY || 0);
      },

      destroy: function() {
        if (this.abortController) this.abortController.abort();
        // Reset scroll state on old element before releasing reference
        if (this.header) {
          this.header.setAttribute('data-scroll-state', 'default');
          this.header.style.removeProperty('--scroll-fade-progress');
          this.header.style.removeProperty('--header-glass-offset');
        }
        this.header = null;
        this.currentState = 'default';
        this.ticking = false;
      },

      _detectTransparentPage: function() {
        if (this.scrollBehavior === 'off') return false;
        var bc = document.body.className;
        var loc = window.location.pathname;
        var isHome = bc.includes('template-index') || loc === '/' || loc === '';
        var isCollection = bc.includes('template-collection');
        var isProduct = bc.includes('template-product');
        var isPageTpl = bc.includes('template-page');

        if (isHome && this.header.dataset.transparentHome === 'true') return true;
        if (isCollection && this.header.dataset.transparentCollection === 'true') return true;
        if (isProduct && this.header.dataset.transparentProduct === 'true') return true;
        if (isPageTpl && this.header.dataset.transparentPage === 'true') return true;

        if (this.header.dataset.transparentSpecific) {
          var currentPath = loc.replace(/\/$/, '');
          var pages = this.header.dataset.transparentSpecific.split('\n');
          for (var i = 0; i < pages.length; i++) {
            if (pages[i].trim().replace(/\/$/, '') === currentPath) return true;
          }
        }
        return false;
      },

      _onScroll: function() {
        if (this.ticking) return;
        this.ticking = true;
        var self = this;
        requestAnimationFrame(function() {
          var scrollY = window.scrollY || 0;
          self._update(scrollY);
          self._updateTriggerClip();
          self.ticking = false;
        });
      },

      _update: function(scrollY) {
        if (this.staticBgEl) {
          this.header.classList.toggle('header--static-bg-scrolled', scrollY > 0);
        }

        // Glass offset animation: header starts flush at top, gradually moves
        // down to center within the static bg as the user scrolls.
        // Animates over 150px of scroll — completely imperceptible.
        if (this.maxGlassOffset > 0) {
          var offsetProgress = Math.min(scrollY / 150, 1);
          var offset = Math.round(offsetProgress * this.maxGlassOffset * 100) / 100;
          this.header.style.setProperty('--header-glass-offset', offset + 'px');
        }

        // Drawer open: force revealed state
        if (document.body.classList.contains('drawer-open')) {
          this._setState('revealed');
          return;
        }

        if (this.scrollBehavior === 'off' || !this.transparentOnPage) {
          this._setState('default');
          return;
        }

        if (this.scrollBehavior === 'threshold') {
          this._setState(scrollY >= this.revealPosition ? 'revealed' : 'transparent');
        } else if (this.scrollBehavior === 'fade') {
          if (scrollY < this.revealPosition) {
            this._setState('transparent');
          } else {
            var progress = (scrollY - this.revealPosition) / this.fadeRange;
            progress = Math.round(Math.min(progress * this.fadeMax, 1) * 100) / 100;
            this.header.style.setProperty('--scroll-fade-progress', progress);
            this._setState('revealing');
            if (progress >= this.fadeMax) {
              this._applyColors('revealed');
            }
          }
        }
      },

      _setState: function(state) {
        if (state === this.currentState) return;
        this.currentState = state;
        this.header.setAttribute('data-scroll-state', state);
        this._applyColors(state);
      },

      _applyColors: function(state) {
        if (state === 'transparent' || state === 'revealing') {
          this.header.style.setProperty('--header-bg-color', 'transparent');
          this.header.style.setProperty('--header-border-color', 'var(--header-transparent-border)');
          this.header.style.setProperty('--header-text-color', 'var(--header-transparent-text)');
          this.header.style.setProperty('--nav-text-color', 'var(--header-transparent-nav)');
          this.header.style.setProperty('--cart-count-color', 'var(--header-transparent-cart-count)');
        } else if (state === 'revealed') {
          this.header.style.setProperty('--header-bg-color', this.origBg);
          this.header.style.setProperty('--header-border-color', this.origBorder);
          this.header.style.setProperty('--header-text-color', this.origText);
          this.header.style.setProperty('--nav-text-color', this.origNav);
          this.header.style.setProperty('--cart-count-color', this.origCartCount);
        } else {
          // default — restore original colors
          this.header.style.setProperty('--header-bg-color', this.origBg);
          this.header.style.setProperty('--header-border-color', this.origBorder);
          this.header.style.setProperty('--header-text-color', this.origText);
          this.header.style.setProperty('--nav-text-color', this.origNav);
          this.header.style.setProperty('--cart-count-color', this.origCartCount);
        }
      },

      // --- Trigger System (static bg clip-path) ---
      // Live getBoundingClientRect() read every scroll frame. No caching —
      // font loads, lazy images, and any other post-init layout shift can
      // never produce a stale trigger Y. H comes from .offsetHeight of the
      // static bg, so it always reflects --header-height + --bg-padding as
      // configured in the theme editor.
      _updateTriggerClip: function() {
        if (!this.hasTriggers) return;

        var H = this.staticBgEl ? this.staticBgEl.offsetHeight : 0;
        if (H <= 0) H = 60;

        var startTop = this.hasStart ? this.startEl.getBoundingClientRect().top : null;
        var endTop = this.hasEnd ? this.endEl.getBoundingClientRect().top : null;

        var topFrac = 0, bottomFrac = 0;

        // Inverted placement (end trigger above start trigger in the doc):
        // bg stays visible outside the [end, start] range and clips only between them.
        if (startTop !== null && endTop !== null && startTop > endTop) {
          if (endTop < 0 && startTop > 0) {
            topFrac = Math.max(0, Math.min(1, startTop / H));
            bottomFrac = Math.max(0, Math.min(1, -endTop / H));
          }
        } else {
          if (startTop !== null) topFrac = Math.max(0, Math.min(1, startTop / H));
          if (endTop !== null) bottomFrac = Math.max(0, Math.min(1, -endTop / H));
        }

        topFrac = Math.round(topFrac * 1000) / 1000;
        bottomFrac = Math.round(bottomFrac * 1000) / 1000;
        var key = topFrac + '|' + bottomFrac;
        if (key !== this.lastClipKey) {
          document.documentElement.style.setProperty('--trigger-clip-top', String(topFrac));
          document.documentElement.style.setProperty('--trigger-clip-bottom', String(bottomFrac));
          window.__headerBgTriggerProgress = 1 - Math.max(topFrac, bottomFrac);
          this.lastClipKey = key;
        }
      }
    };

    // Initialize scroll controller
    window.StackdHeader.init();

    // Re-initialize on section re-render in the theme editor
    document.addEventListener('shopify:section:load', function(e) {
      if (!e.target || !e.target.querySelector || !e.target.querySelector('.site-header')) return;
      window.StackdHeader.destroy();
      window.StackdHeader.init();
    });

    // ---------- Context-Aware Header Styling ----------
    // Uses IntersectionObserver — no scroll listeners.
    (function() {
      var contextSections = document.querySelectorAll(
        '[data-header-skin], [data-header-bg], [data-header-border]'
      );
      if (!contextSections.length) return;

      var contextClasses = [
        'header--skin-light', 'header--skin-dark',
        'header--bg-transparent', 'header--bg-solid',
        'header--border-hidden', 'header--border-visible'
      ];
      var activeSections = new Set();

      function clearContextClasses() {
        contextClasses.forEach(function(cls) { header.classList.remove(cls); });
      }

      function applySection(el) {
        clearContextClasses();
        var skin = el.getAttribute('data-header-skin');
        var bg = el.getAttribute('data-header-bg');
        var border = el.getAttribute('data-header-border');
        if (skin === 'light') header.classList.add('header--skin-light');
        if (skin === 'dark') header.classList.add('header--skin-dark');
        if (bg === 'transparent') header.classList.add('header--bg-transparent');
        if (bg === 'solid') header.classList.add('header--bg-solid');
        if (border === 'false' || border === 'hidden') header.classList.add('header--border-hidden');
        if (border === 'true' || border === 'visible') header.classList.add('header--border-visible');
      }

      function updateActiveSection() {
        if (activeSections.size === 0) { clearContextClasses(); return; }
        var topSection = null, topOffset = Infinity;
        activeSections.forEach(function(el) {
          var d = Math.abs(el.getBoundingClientRect().top);
          if (d < topOffset) { topOffset = d; topSection = el; }
        });
        if (topSection) applySection(topSection);
      }

      var headerHeight = header.offsetHeight || 60;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) activeSections.add(entry.target);
          else activeSections.delete(entry.target);
        });
        updateActiveSection();
      }, {
        root: null,
        rootMargin: '0px 0px -' + (window.innerHeight - headerHeight) + 'px 0px',
        threshold: 0
      });

      contextSections.forEach(function(el) { observer.observe(el); });

      document.addEventListener('shopify:section:load', function() {
        observer.disconnect();
        activeSections.clear();
        clearContextClasses();
        document.querySelectorAll('[data-header-skin], [data-header-bg], [data-header-border]')
          .forEach(function(el) { observer.observe(el); });
      });
    })();

  });

  // Search toggle — delegated listener that survives section re-renders
  // Uses event delegation on document so the handler works even when the
  // header section is re-rendered in the theme editor (which replaces the
  // .search-toggle element and does NOT re-fire DOMContentLoaded).
  (function() {
    if (window.__stackdSearchToggleBound) return;
    window.__stackdSearchToggleBound = true;
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('.search-toggle');
      if (!toggle) return;
      e.preventDefault();
      if (window.searchDrawer && typeof window.searchDrawer.open === 'function') {
        window.searchDrawer.open();
      }
    });
  })();

  // Desktop nav dropdown — delegated listener that survives section re-renders
  // Handles: hover open/close with safe zones, click/touch toggle, ESC close,
  // outside-click close, keyboard navigation, iPad/touch device support
  (function() {
    if (window.__stackdDesktopDropdownBound) return;
    window.__stackdDesktopDropdownBound = true;

    // Detect touch-capable devices (iPad, phones, hybrid laptops)
    var isTouchDevice = false;
    function detectTouch() {
      isTouchDevice = ('ontouchstart' in window) ||
                      (navigator.maxTouchPoints > 0) ||
                      (navigator.msMaxTouchPoints > 0);
    }
    detectTouch();
    // Re-detect on first touch (handles hybrid devices like Surface)
    window.addEventListener('touchstart', function onFirstTouch() {
      isTouchDevice = true;
      window.removeEventListener('touchstart', onFirstTouch);
    }, { passive: true });

    var closeTimers = new WeakMap();
    var HOVER_CLOSE_DELAY = 300; // Longer delay for forgiving hover zones

    function openDropdown(dropdown) {
      // Cancel any pending close
      var timer = closeTimers.get(dropdown);
      if (timer) { clearTimeout(timer); closeTimers.delete(dropdown); }
      dropdown.classList.add('is-open');
      var toggle = dropdown.querySelector('[data-desktop-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown(dropdown) {
      closeTimers.delete(dropdown);
      dropdown.classList.remove('is-open');
      var toggle = dropdown.querySelector('[data-desktop-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose(dropdown) {
      var existing = closeTimers.get(dropdown);
      if (existing) clearTimeout(existing);
      var timer = setTimeout(function() {
        closeDropdown(dropdown);
        closeTimers.delete(dropdown);
      }, HOVER_CLOSE_DELAY);
      closeTimers.set(dropdown, timer);
    }

    function closeAllDropdowns() {
      document.querySelectorAll('[data-desktop-dropdown].is-open').forEach(function(d) {
        var timer = closeTimers.get(d);
        if (timer) { clearTimeout(timer); closeTimers.delete(d); }
        closeDropdown(d);
      });
    }

    // ─── HOVER BEHAVIOR (non-touch devices only) ───
    // mouseenter/mouseleave on the ENTIRE dropdown container (toggle + menu)
    // Using capture phase to catch events on child elements
    document.addEventListener('mouseenter', function(e) {
      if (isTouchDevice) return;
      var dropdown = e.target.closest('[data-desktop-dropdown]');
      if (!dropdown) return;
      openDropdown(dropdown);
    }, true);

    document.addEventListener('mouseleave', function(e) {
      if (isTouchDevice) return;
      var dropdown = e.target.closest('[data-desktop-dropdown]');
      if (!dropdown) return;
      // Check if we're moving to another element inside the same dropdown
      var related = e.relatedTarget;
      if (related && dropdown.contains(related)) return;
      scheduleClose(dropdown);
    }, true);

    // Also listen for mouseover on the dropdown menu itself to cancel close
    document.addEventListener('mouseover', function(e) {
      if (isTouchDevice) return;
      var dropdown = e.target.closest('[data-desktop-dropdown]');
      if (!dropdown || !dropdown.classList.contains('is-open')) return;
      // Mouse is back inside the dropdown — cancel close
      var timer = closeTimers.get(dropdown);
      if (timer) { clearTimeout(timer); closeTimers.delete(dropdown); }
    }, true);

    // ─── CLICK / TOUCH BEHAVIOR ───
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-desktop-dropdown-toggle]');
      if (toggle) {
        e.preventDefault();
        var dropdown = toggle.closest('[data-desktop-dropdown]');
        if (dropdown) {
          if (dropdown.classList.contains('is-open')) {
            closeDropdown(dropdown);
          } else {
            closeAllDropdowns();
            openDropdown(dropdown);
            // Also close region dropdown if open
            var regionMenu = document.querySelector('[data-region-dropdown-menu]');
            if (regionMenu) regionMenu.classList.remove('is-open');
            var regionToggle = document.querySelector('[data-region-toggle]');
            if (regionToggle) regionToggle.setAttribute('aria-expanded', 'false');
          }
        }
        return;
      }
      // Click outside closes all (works for touch devices too)
      if (!e.target.closest('[data-desktop-dropdown]')) {
        closeAllDropdowns();
      }
    });

    // ─── KEYBOARD NAVIGATION ───
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var openDd = document.querySelector('[data-desktop-dropdown].is-open');
        if (openDd) {
          closeDropdown(openDd);
          var toggle = openDd.querySelector('[data-desktop-dropdown-toggle]');
          if (toggle) toggle.focus();
        }
      }
      // Arrow key navigation inside dropdown
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var openDd = document.querySelector('[data-desktop-dropdown].is-open');
        if (!openDd) return;
        var items = openDd.querySelectorAll('[role="menuitem"]');
        if (!items.length) return;
        e.preventDefault();
        var focused = openDd.querySelector('[role="menuitem"]:focus');
        var idx = Array.prototype.indexOf.call(items, focused);
        if (e.key === 'ArrowDown') {
          idx = (idx + 1) % items.length;
        } else {
          idx = idx <= 0 ? items.length - 1 : idx - 1;
        }
        items[idx].focus();
      }
      // Enter/Space on toggle opens and focuses first item
      if (e.key === 'Enter' || e.key === ' ') {
        var toggle = e.target.closest('[data-desktop-dropdown-toggle]');
        if (toggle) {
          e.preventDefault();
          var dropdown = toggle.closest('[data-desktop-dropdown]');
          if (dropdown && !dropdown.classList.contains('is-open')) {
            openDropdown(dropdown);
            var firstItem = dropdown.querySelector('[role="menuitem"]');
            if (firstItem) setTimeout(function() { firstItem.focus(); }, 50);
          }
        }
      }
    });
  })();

  /* ── Region / Localization Dropdown (Desktop) ── */
  (function() {
    var wrapper = document.querySelector('[data-region-dropdown]');
    if (!wrapper) return;

    var toggle = wrapper.querySelector('[data-region-toggle]');
    var menu = wrapper.querySelector('[data-region-dropdown-menu]');
    var select = wrapper.querySelector('.header-region-select');
    if (!toggle || !menu) return;

    function open() {
      menu.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function close() {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Close any open desktop-nav dropdowns
      document.querySelectorAll('[data-desktop-dropdown].is-open').forEach(function(dd) {
        dd.classList.remove('is-open');
        var t = dd.querySelector('[data-desktop-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (menu.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target)) {
        close();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        close();
        toggle.focus();
      }
    });

    // Auto-submit on select change
    if (select) {
      select.addEventListener('change', function() {
        var form = select.closest('form');
        if (form) form.submit();
      });
    }
  })();



  } catch(e) { console.error(e); }
})();
})();
